import { ADD_TALENT_SPECIALTY_PRO } from '@gql/talentSpecialties';
import { FormControl, FormLabel } from '@mui/material';
import * as React from 'react';
import { Controller } from 'react-hook-form';
import { AutoCompleteField } from './AutoCompleteField';
import { NestedSubOption, Props } from './types';
import { flatten } from './utils';

export function AutoCompleteTalentSpecialties({
    control,
    name,
    label,
    placeholder,
    disabled,
    options,
    groupedOptions,
    defaultValue,
    ...props
}: Props) {
    const _options = React.useMemo(() => {
        return (groupedOptions ? flatten(groupedOptions) : options) || [];
    }, [groupedOptions, options]);

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue || []}
            render={({ field: { onChange, value } }) => (
                <FormControl fullWidth>
                    <FormLabel htmlFor={name}>
                        {label}
                    </FormLabel>

                    <AutoCompleteField
                        viewOnly={props.viewOnly}
                        options={_options}
                        value={value}
                        onChange={val => {
                            onChange(val);
                            props.onChange?.(val);
                        }}
                        label={label}
                        mutation={ADD_TALENT_SPECIALTY_PRO}
                        placeholder={placeholder}
                        disabled={disabled}
                        allowAdd={props.allowAdd}
                        multiple={true}
                        groupBy={groupedOptions ? (option: NestedSubOption) => option?.parent?.name : undefined}
                    />
                </FormControl>
            )}
        />
    );
}
